import React from 'react'

const LogoLine = (): JSX.Element => {
  return (
    <svg
      width="1"
      height="11"
      viewBox="0 0 1 11"
      fill="none"
      xmlns="player"
      style={{ marginLeft: '5px' }}
    >
      <line x1="0.5" y1="2.18557e-08" x2="0.5" y2="11" stroke="#C5C5C5" />
    </svg>
  )
}

export default LogoLine
